var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "url-content",
      attrs: { id: _vm.id },
      on: { mousedown: _vm.focus, touchstart: _vm.focus }
    },
    [
      _c("div", { staticClass: "url-content__handle tooltip-drag-handle" }, [
        _vm._v("::::::")
      ]),
      _vm._v(" "),
      _vm.linkType === "simple"
        ? _c(
            "blockquote",
            { staticClass: "url-content__container", attrs: { cite: _vm.url } },
            [
              _c("div", { staticClass: "url-content__body" }, [
                _c("h4", { staticClass: "url-content__title" }, [
                  _vm._v(_vm._s(_vm.title))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "url-content__description" }, [
                  _vm._v(_vm._s(_vm.description))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "url-content__domain" }, [
                  _vm._v(_vm._s(_vm.domain))
                ])
              ])
            ]
          )
        : _vm.linkType === "rich"
          ? _c(
              "blockquote",
              {
                staticClass: "url-content__container",
                attrs: { cite: _vm.url }
              },
              [
                _c("div", [
                  _c("div", { staticClass: "url-content__thumbnail" }, [
                    _c("div", { staticClass: "url-content__image-container" }, [
                      _vm.thumbnailUrl
                        ? _c("img", {
                            style:
                              "background-image: url(" + _vm.thumbnailUrl + ")",
                            attrs: {
                              alt: _vm.title,
                              src:
                                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII="
                            }
                          })
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "url-content__body" }, [
                    _c("h4", { staticClass: "url-content__title" }, [
                      _vm._v(_vm._s(_vm.title))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "url-content__description" }, [
                      _vm._v(_vm._s(_vm.description))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "url-content__domain" }, [
                      _vm._v(_vm._s(_vm.domain))
                    ])
                  ])
                ])
              ]
            )
          : _vm.linkType === "embed"
            ? _c(
                "blockquote",
                {
                  staticClass:
                    "url-content__container url-content__container--embed",
                  attrs: { cite: _vm.url }
                },
                [_c("div", { domProps: { innerHTML: _vm._s(_vm.html) } })]
              )
            : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _c(
          "button",
          {
            staticClass: "url-content__delete tooltip-delete",
            on: {
              click: function($event) {
                _vm.deleteComponent()
              }
            }
          },
          [_vm._v("×\n    ")]
        )
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "menu-effect" } }, [
        _vm.hasFocus
          ? _c("div", { staticClass: "menu-container" }, [
              _c("ul", { staticClass: "menu-container__item" }, [
                _c(
                  "li",
                  {
                    staticClass: "menu-button tooltip-edit-url",
                    on: { click: _vm.showEditor }
                  },
                  [_c("span", { staticClass: "fi-pencil" })]
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "overlay-transition" } }, [
        _vm.isEditorVisible
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "escape-key",
                    rawName: "v-escape-key",
                    value: _vm.hideEditor,
                    expression: "hideEditor"
                  }
                ],
                staticClass: "overlay-background",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    return _vm.hideEditor($event)
                  }
                }
              },
              [
                _c("url-editor", {
                  staticClass: "url-editor reveal",
                  attrs: {
                    value: _vm.url,
                    title: "URLの編集",
                    submitLabel: "保存"
                  },
                  on: {
                    input: _vm.trackInputUrl,
                    submit: _vm.saveContent,
                    close: _vm.trackClose
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.isMaskVisible
        ? _c("div", { staticClass: "url-content__mask" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }